import { Component } from '@angular/core';
import { HeaderModel, FooterModel } from '../models/app.model';

@Component({
  selector: 'app-root',
  templateUrl:'./../views/app.component.html',
  styleUrls: ['./../css/app.component.css']
})
export class AppComponent {
  public cabezera: HeaderModel;
  public footerMSn: FooterModel;
  
  constructor(){

    this.cabezera = new HeaderModel("Gestor de Pacientes");
    this.footerMSn =  new FooterModel("Copyright © ",
    " IT-Solutions SpA.",
    " la copia total o parcial de esta aplicación o su codigo fuente estan penadas por la ley de derecho de autor");
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/